import { createAppRequest } from '@/services/request';

export interface OpenPlatformTokenResult {
  accessToken: string;
}

export interface TaskManagementTokenResult {
  accessToken: string;
  expiresAt?: number;
}

/** 当前组织开放平台 M2M Token：通知/权限管理等场景 */
export function getOpenPlatformToken() {
  return createAppRequest()<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}

/** 任意已登录成员：zy-task NPM 组件用 */
export function getTaskManagementToken() {
  return createAppRequest()<TaskManagementTokenResult>(
    '/bff/open-platform/task-management-token',
    { method: 'GET' },
  );
}
